export default __webpack_public_path__ + "static/media/logo-bressanidev-light.a5eb6913.svg";